import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ProjectDto } from '@admin/models/project-dto';
import { convertToLocal } from '@admin/pages/projects/util/date-helper';

export const buildProjectForm = (
  formBuilder: UntypedFormBuilder,
  project: ProjectDto | null = null,
): UntypedFormGroup => {
  const form = formBuilder.group({
    id: [{ value: '', disabled: !!project }, Validators.required],
    name: ['', Validators.required],
    divisionType: ['', Validators.required],
    completionType: [''],
    originType: [''],
    externalId: [{ value: '', disabled: !!project }, Validators.required],
    progressCutOffDay: [],
    progressCutOffTime: ['', Validators.pattern(/^([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9])$/)],
    jobFeedbackRecipientEmail: ['', Validators.email],
    weightChangeRecipientEmail: ['', Validators.email],
  });

  if (project) {
    const existingProject = { ...project };
    if (existingProject.progressCutOffTime) {
      existingProject.progressCutOffTime = convertToLocal(existingProject.progressCutOffTime);
    }
    form.patchValue(existingProject);
  }

  return form;
};
